import React from "react";
import { useNavigate } from "react-router-dom";
import "../assets/css/Error404Page.css";

const Error404Page = () => {
  const navigate = useNavigate();

  return (
    <main className="error-page" data-page-status="404">
      <section className="container">
        <div className="error-card">
          <p className="error-label">ERROR 404</p>
          <h1 className="error-code">404</h1>
          <h2 className="error-title">Page not found</h2>
          <p className="error-text">
            The page you are looking for could not be found or may have been moved.
          </p>
          <div className="error-actions">
            <button
              className="btn main-btn"
              type="button"
              onClick={() => navigate("/")}
            >
              Go to home page
            </button>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Error404Page;
